import {Component, Input} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {LoginRequest} from "../../../../modules/auth/models/login-request";
import {AuthService} from "../../../../modules/auth/services/auth-service";
import {ToastrService} from "ngx-toastr";
import {Router} from "@angular/router";
import {BaseResponse} from "../../../models/base-response";
import {Token} from "../../../../modules/auth/models/token";
import { SecretariaService } from '../../../services/secretaria.service';
import { ChatUiService } from '../../../services/chat-ui.service';
import { UsuarioService } from '../../../../modules/auth/services/usuario-service';

@Component({
    selector: 'app-formulario',
    templateUrl: './formulario.component.html',
    styleUrl: './formulario.component.css',
    standalone: false
})
export class FormularioComponent {
  formLogin: FormGroup;
  request = new LoginRequest();
  mostrarRecuperacao = false;
  emailRecuperacao = '';
  enviandoRecuperacao = false;

  constructor(private authService: AuthService,
              private formBuilder: FormBuilder,
              private toastr: ToastrService,
              private router: Router,
              private secretariaService: SecretariaService,
              private chatUi: ChatUiService,
              private usuarioService: UsuarioService) {
    this.construirFormLogin();
  }

  public logar(){
    this.preencherModelo();
    this.authService.login(this.request).subscribe(
      (response: BaseResponse<Token>) => {
        this.authService.setAccessToken(response.dados);
        this.toastr.success('Login feito com sucesso');

        // Fechar todos os chats ao fazer login
        try { this.secretariaService.fechar(); } catch {}
        try { this.chatUi.closeAll(); } catch {}

        this.redirecionamentoSucesso(response.dados);
      },
      (error) => {
        this.toastr.error(error);
      }
    );
  }

  private preencherModelo(){
    this.request.email = this.formLogin.controls[`email`].value;
    this.request.senha = this.formLogin.controls[`senha`].value;
    this.request.tipoSaas = 3;
  }

  private redirecionamentoSucesso(token: Token) {
    this.router.navigateByUrl(token.seguranca === 'SDR' ? '/venda-ativa' : '/');
  }

  private construirFormLogin(){
    this.formLogin = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email, Validators.maxLength(200)]],
      senha: ['', [Validators.required, Validators.maxLength(20)]]
    });
  }
  recuperarSenha() {
    if (!this.emailRecuperacao || !this.emailRecuperacao.includes('@')) { this.toastr.warning('Informe um e-mail válido.'); return; }
    this.enviandoRecuperacao = true;
    this.usuarioService.esqueciSenha(this.emailRecuperacao).subscribe({
      next: () => { this.enviandoRecuperacao = false; this.mostrarRecuperacao = false; this.toastr.success('Se o e-mail estiver cadastrado, a senha temporária será enviada.'); },
      error: () => { this.enviandoRecuperacao = false; this.toastr.error('Não foi possível solicitar a recuperação agora.'); }
    });
  }
}
